module.exports = __webpack_public_path__ + "static/media/4beforeaftersecond.702fff00.jpg";